module.exports = __webpack_public_path__ + "img/headerCleverlab.18554c87.png";